import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getConfectioneryDetail,
  formatCurrency,
  getTotalCombos,
} from "../../utils/confectioneryManager";
import { useCheckoutStore } from "../../store/useCheckoutStore";
import { useSettingsStore } from "../../context/useSettingsStore.js";
import { useCancelReserveShowtime } from "../../hooks/useCheckoutQueries.js";
import { showAlert } from "../../utils/Alert.js";
import Resume from "../ConfectioneryProductModal/Resume";
import Timer from "../Timer/Timer";
import ComboQuantityControl from "../ComboQuantityControl/ComboQuantityControl";
import logo from "../../assets/images/logo-viziona-white.png";
import "./checkout.css";
import { pay } from "../../services/redebanService";
import { useRedebanStore } from "../../store/useRedebanStore";
import { useVizionarioStore } from "../../store/useVizionarioStore.js";

Checkout.propTypes = {
  confectioneryCombos: PropTypes.array,
  locations: PropTypes.array,
  payBrands: PropTypes.array,
  onClose: PropTypes.func,
  movie: PropTypes.object,
  showtime: PropTypes.object,
  seats: PropTypes.array,
};

export default function Checkout(props) {
  const {
    confectioneries_api,
    bookingDetails: {
      confectioneryCombos,
      showtime,
      movie,
      totalTickets,
      totalConfectionery,
      location,
      totalService,
      total,
    },
    selectedSeats: seats,
    setBookingDetails,
    removeConfectioneryCombo,
    updateConfectioneryCombo,
  } = useCheckoutStore();
  const isVizionario = useVizionarioStore((state) => state.isVizionario);
  const redebanInProgress = useRedebanStore((state) => state.inProgress);

  const { ticketService, confectioneryService } = useSettingsStore();
  const [totalServiceTicket, setTotalServiceTicket] = useState(0);
  const [serviceConfectionery, setServiceConfectionery] = useState(0);
  const [ticketsSaving, setTicketsSaving] = useState(0);
  const [confectionerySaving, setConfectionerySaving] = useState(0);

  useEffect(() => {
    let total = 0;
    let totalSaving = 0;
    seats.forEach(() => {
      total += location.valor;
      totalSaving += location.difference;
    });
    setTicketsSaving(totalSaving);
    setBookingDetails({ totalTickets: total });
  }, [seats, location, setBookingDetails]);
  const cancelReserveMutation = useCancelReserveShowtime();
  const navigate = useNavigate();

  useEffect(() => {
    let { totalGeneral, totalOthers, saving } =
      getTotalCombos(confectioneryCombos);
    setBookingDetails({
      totalConfectionery: isVizionario ? totalOthers : totalGeneral,
    });
    setConfectionerySaving(saving);
  }, [confectioneryCombos, setBookingDetails, location]);

  useEffect(() => {
    let total = 0;
    let serviceTicket = 0;
    let serviceConfectionery = 0;
    seats.forEach(() => {
      serviceTicket += ticketService;
    });
    confectioneryCombos.forEach(() => {
      serviceConfectionery += confectioneryService;
    });

    total = serviceTicket + serviceConfectionery;
    setTotalServiceTicket(serviceTicket);
    setServiceConfectionery(serviceConfectionery);
    setBookingDetails({ totalService: total });
  }, [
    confectioneryCombos,
    confectioneryService,
    seats,
    setBookingDetails,
    ticketService,
    totalServiceTicket,
  ]);

  useEffect(() => {
    let total = totalConfectionery + totalTickets;
    setBookingDetails({ subtotal: total });
  }, [totalConfectionery, totalTickets, totalService, setBookingDetails]);

  useEffect(() => {
    let total = totalConfectionery + totalTickets + totalService;
    setBookingDetails({ total: total });
  }, [totalConfectionery, totalTickets, totalService, setBookingDetails]);

  useEffect(() => {
    setBookingDetails({ payType: 1 });
  }, [setBookingDetails]);

  const handleCancelReservation = () => {
    if (!redebanInProgress) {
      showAlert({
        text: "Se termino el tiempo de la reserva.",
        callAction: () => {
          cancelReserveMutation.mutate(showtime.id, {
            onSuccess: () => {
              navigate("/banners");
            },
          });
        },
      });
    }
  };

  return (
    <>
      <div className="checkout">
        <Timer
          endTime={10}
          onFinishTimer={handleCancelReservation}
          label="Tiempo restante de la reserva"
        />
        <div className="checkout-header">
          <h2>Detalle de la Compra</h2>
        </div>
        <div className="checkout-body">
          <div className="checkout-body-item">
            <div className="checkout-body-item-image">
              <img src={movie.poster} alt="" />
            </div>
            <div className="checkout-body-item-info">
              <p>
                <strong>{movie.title}</strong>
              </p>
              <p>
                <strong>Fecha Función: </strong>
                {showtime.date_string}
              </p>
              <p>
                <strong>Hora: </strong>
                {showtime.hour_string}
              </p>
              <p>
                <strong>Sillas: </strong>
                {seats.map((seat, index) => (
                  <span key={index}>
                    {seat.FilRelativa}
                    {seat.ColRelativa}
                    {index < seats.length - 1 ? " - " : ""}
                  </span>
                ))}
              </p>
            </div>
          </div>

          {confectioneryCombos.length >= 1 &&
            confectioneryCombos.map((combo) => {
              const comboApi = getConfectioneryDetail(
                combo.Codigo,
                confectioneries_api
              );

              const handleQuantityChange = (newCantidad) => {
                updateConfectioneryCombo({
                  ...combo,
                  Cantidad: newCantidad,
                });
              };

              return (
                <div key={combo.Codigo} className="checkout-body-item">
                  <div className="checkout-body-item-image">
                    {comboApi.image !== "" ? (
                      <img src={comboApi.image} alt="" />
                    ) : (
                      <div className="fallback">
                        <img src={logo} />
                      </div>
                    )}

                    <ComboQuantityControl
                      cantidad={combo.Cantidad}
                      onChange={handleQuantityChange}
                    />
                  </div>
                  <div className="checkout-body-item-info">
                    <p>
                      <strong>{comboApi.name}</strong>
                    </p>
                    <Resume
                      recipe={combo.Receta}
                      productApi={comboApi}
                      showTitle={false}
                    />
                  </div>
                  <div className="checkout-body-item-remove">
                    <button onClick={() => removeConfectioneryCombo(combo)}>
                      <span className="icon-trash" />
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="checkout-footer">
          <div className="checkout-totals">
            <div className="checkout-totals-item">
              <p>Valor Entradas:</p>
              <p>{formatCurrency(totalTickets)}</p>
            </div>
            <div className="checkout-totals-item">
              <p>Valor Confiteria:</p>
              <p>{formatCurrency(totalConfectionery)}</p>
            </div>
            <div className="checkout-totals-item">
              <p>Cargo por Servicio:</p>
              <p>{formatCurrency(totalService)}</p>
            </div>
          </div>
          <div className="checkout-total">
            <p>Total:</p>
            <p className="total">{formatCurrency(total)}</p>
          </div>
          <div className="checkout-is-vizionario">
            <p className="what-if">
              {isVizionario ? (
                <>
                  Por ser <strong>Club Vizionarios</strong> ahorraste
                </>
              ) : (
                <>
                  Por ser <strong>Club Vizionarios</strong> te habrías ahorrado
                </>
              )}
            </p>
            <p className="what-if-total">
              {formatCurrency(ticketsSaving + confectionerySaving)}
            </p>
          </div>

          <button className="end-button" onClick={pay}>
            Finalizar compra
          </button>
        </div>
      </div>
    </>
  );
}
